module.exports = __webpack_public_path__ + "img/img_activation_email_2.cb19d134.png";